module.exports = __webpack_public_path__ + "icon_database_40x40.svg";